import React, { Component } from 'react'
import Web3 from 'web3'
import Box1_0 from '../Box1_0/Box1_0';
import BoxesInstallerManager from '../BoxesInstallerManager/BoxesInstallerManager';
import './css.css';
import utils from './../../library';




class BoxModules extends Component {
constructor(props){
    super()
    this.loadModules = this.loadModules.bind(this)
this.state={enabled_items:[]}
this.renderAgain = this.renderAgain.bind(this);
this.showBox = this.showBox.bind(this);
}



renderAgain(){
    this.loadModules()
    this.render()

}


showBox(addr,ind){
    this.props.showBox(addr,ind)
}

    componentDidMount(){
      this.loadModules()
      utils.loadOwnerColors()
    }


async loadModules(){
    let total_modules=[]
    let rendAgain=() => this.renderAgain
    let showBoxx=this.showBox
    console.log("ENTER");
    await window.ethereum.enable().then(async function (accounts) {  
        const { REACT_APP_OWNERSHIPABI } = process.env;
        const { REACT_APP_OWNERSHIP } = process.env; 
        try{
        const ownsership = new web3.eth.Contract(JSON.parse(REACT_APP_OWNERSHIPABI), REACT_APP_OWNERSHIP) 
        console.log(await ownsership.methods.owned(accounts[0],0).call());   
        let owned=await ownsership.methods.owned(accounts[0],0).call()
        console.log("COUNT"+owned[1]);
        for(let i=0;i<owned[1];i++){
            let addr
            addr=await ownsership.methods.owned(accounts[0],i).call()
            console.log("MODULE ADDRESS: "+addr[0])
            let code=0
            let t
            t=<Box1_0 address={addr[0]} key={i} index={i} enabled={true} reset={rendAgain} showBox={showBoxx}></Box1_0>
            total_modules.push(t)               
        }     
    }catch(e){console.log("BoxModules loadModules()",e)}
    })
    this.setState({enabled_items : total_modules})
    this.render()
}

    render(props){
    console.log(this.state.enabled_items)

    
        return ( 
        <div className="HappyBoxes_Panel dark darkblue">
            <div className="HappyBoxes_mainlabel"> HappyBoxes 📦 </div> 
            <div className="clear"></div> 
            <div className="HappyBoxes_Container light lightblue">  
                {
                  this.state.enabled_items  
                } 

<BoxesInstallerManager reset={() => this.renderAgain()} showBox={this.showBox}></BoxesInstallerManager>
              
            </div>
        </div>
            
        );
    }


}

function getUrlVars() {
    var vars = {};
    var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
        vars[key] = value;
    });
    return vars;
}


        
const web3 = new Web3(Web3.givenProvider || "http://localhost:8545")




export default BoxModules